import React from 'react';

import { Toolbar } from './components/Toolbar';
import { PluginPreviewPage } from './components/PluginPreviewPage';
import { LessonPreviewLayout } from 'components/Layout';

import styles from './ColorMatchLessonPreviewPage.module.scss';

const ColorMatchLessonPage = ({
  nextLoading,
  isLastLessonInCourse,
  submitted,
  imageRef,
  lesson,
  currentColor,
  currentImage,
  matchPercent,
  onColorChange,
  openReportLessonModal,
  onCheckColorClick,
  onNextLessonClick,
  previewType,
  setTestMode,
  setPreviewType,
  onChangePreviewType,
  lessonTitle,
  currentLesson,
  lessonsCount,
  ...props
}: {
  nextLoading: any;
  isLastLessonInCourse: any;
  submitted: any;
  imageRef: any;
  lesson: any;
  currentColor: any;
  currentImage: any;
  matchPercent: any;
  onColorChange: any;
  openReportLessonModal: any;
  onCheckColorClick: any;
  onNextLessonClick: any;
  previewType: any;
  setTestMode: any;
  setPreviewType: any;
  onChangePreviewType: any;
  lessonTitle: any;
  currentLesson: any;
  lessonsCount: any;
  props: any;
}) => {
  return (
    <LessonPreviewLayout
      setPreviewType={setPreviewType}
      setTestMode={setTestMode}
      toolbarComponent={
        <div className={styles.toolbar}>
          <Toolbar
            lessonTitle={lessonTitle}
            currentLesson={currentLesson}
            lessonsCount={lessonsCount}
          />
        </div>
      }
    >
      {previewType === 'Plugin' ? (
        <PluginPreviewPage
          {...props}
          nextLoading={nextLoading}
          isLastLessonInCourse={isLastLessonInCourse}
          submitted={submitted}
          imageRef={imageRef}
          lesson={lesson}
          currentColor={currentColor}
          currentImage={currentImage}
          matchPercent={matchPercent}
          onColorChange={onColorChange}
          openReportLessonModal={openReportLessonModal}
          onCheckColorClick={onCheckColorClick}
          onNextLessonClick={onNextLessonClick}
        />
      ) : (
        <PluginPreviewPage
          {...props}
          nextLoading={nextLoading}
          isLastLessonInCourse={isLastLessonInCourse}
          submitted={submitted}
          imageRef={imageRef}
          lesson={lesson}
          currentColor={currentColor}
          currentImage={currentImage}
          matchPercent={matchPercent}
          onColorChange={onColorChange}
          openReportLessonModal={openReportLessonModal}
          onCheckColorClick={onCheckColorClick}
          onNextLessonClick={onNextLessonClick}
        />
      )}
    </LessonPreviewLayout>
  );
};

export default React.memo(ColorMatchLessonPage) as any;
